import { Box, Typography, useTheme } from "@mui/material";
import patterbackground from "../../../assets/pattern3.svg";
import { tokens } from "../../../theme";

interface Props {
  step: 1 | 2 | 3 | 4;
}

export default function StepHeader({ step }: Props) {

  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${patterbackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        px: 4,
        py: 3,
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1, maxWidth: 500, mx: "auto" }}>
        

        <Box
          sx={{
            display: "grid",
            mt: 2,
            gridTemplateColumns: "28px 1fr 28px 1fr 28px 1fr 28px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: colors.primary[900],
              color: colors.primary[400],
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            1
          </Box>

          <Box
            sx={{
              position: "relative",
              height: "4px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "999px",
              overflow: "hidden",
              mx: "-1px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: step === 1 ? "50%" : "100%",
                backgroundColor: colors.primary[900],
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>

          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: step >= 2 ? colors.primary[900] : "transparent",
              color: step >= 2 ? colors.primary[400] : colors.primary[900],
              border: step < 2 ? "1.5px solid rgba(255,255,255,0.7)" : "none",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            2
          </Box>

          <Box
            sx={{
              position: "relative",
              height: "4px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "999px",
              overflow: "hidden",
              mx: "-1px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: step < 2 ? "0%" : step === 2 ? "50%" : "100%",
                backgroundColor: colors.primary[900],
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>

          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: step >= 3 ? colors.primary[900] : "transparent",
              color: step >= 3 ? colors.primary[400] : colors.primary[900],
              border: step < 3 ? "1.5px solid rgba(255,255,255,0.7)" : "none",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            3
          </Box>

          <Box
            sx={{
              position: "relative",
              height: "4px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "999px",
              overflow: "hidden",
              mx: "-1px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: step < 3 ? "0%" : step === 3 ? "50%" : "100%",
                backgroundColor: colors.primary[900],
                borderRadius: "999px",
                transition: "width 0.35s ease",
              }}
            />
          </Box>

          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              backgroundColor: step >= 4 ? colors.primary[900] : "transparent",
              color: step >= 4 ? colors.primary[400] : colors.primary[900],
              border: step < 4 ? "1.5px solid rgba(255,255,255,0.7)" : "none",
              display: "grid",
              placeItems: "center",
              fontWeight: 700,
              fontSize: "0.82rem",
              zIndex: 2,
            }}
          >
            4
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <Typography
            sx={{
              color: step === 1 ? colors.primary[900] : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 1 ? 700 : 400,
              ml: "-20px",
            }}
          >
            Basic Info
          </Typography>
          <Typography
            sx={{
              color: step === 2 ? colors.primary[900] : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 2 ? 700 : 400,
              ml: "0px",
            }}
          >
            Physical Properties
          </Typography>
          <Typography
            sx={{
              color: step === 3 ? colors.primary[900] : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 3 ? 700 : 400,
              mr: "15px",
            }}
          >
            Finance
          </Typography>
          <Typography
            sx={{
              color: step === 4 ? colors.primary[900] : "rgba(255,255,255,0.65)",
              fontSize: "0.78rem",
              fontWeight: step === 4 ? 700 : 400,
              mr: "-15px",
            }}
          >
            Supplier
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
